<ng-template #templateRef>
	<app-list-item-menu-container>
		<app-customer-status-button [isEditMode]="isEditMode()" [id]="item().id" />
		<app-customer-delete-button
			(onDeleteCalled)="onDeleteResponse($event)"
			[id]="item().id"
			[documentNumber]="item().code" />
	</app-list-item-menu-container>
</ng-template>
